import { render } from "./SettingsInternalPlugin.vue?vue&type=template&id=742d9912&scoped=true"
import script from "./SettingsInternalPlugin.vue?vue&type=script&lang=js"
export * from "./SettingsInternalPlugin.vue?vue&type=script&lang=js"

import "./SettingsInternalPlugin.vue?vue&type=style&index=0&id=742d9912&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742d9912"]])

export default __exports__